import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { RouterModule } from '@angular/router';
import { RightPanelModule } from '@common-modules/right-panel/right-panel.module';
import { CommonSharedModule } from '@common-modules/shared/common-shared.module';
import { IconModule } from '@common-modules/shared/icon/icon.module';
import { KendoSharedModule } from '@common-modules/shared/kendo-shared.module';
import { MaterialSharedModule } from '@common-modules/shared/material-shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { HideNavbarsService } from './hide-navbars.service';
import { MenuLinkComponent } from './menu-link/menu-link.component';
import { ModuleLinkExpandableComponent } from './module-link-expandable/module-link-expandable.component';
import { ModuleLinkMenuComponent } from './module-link-menu/module-link-menu.component';
import { NavBarComponent } from './nav-bar/nav-bar.component';
import { VersionInfoItemComponent } from './version-info-item/version-info-item.component';

@NgModule({
  declarations: [
    NavBarComponent,
    ModuleLinkExpandableComponent,
    ModuleLinkMenuComponent,
    MenuLinkComponent,
    VersionInfoItemComponent,
  ],
  exports: [NavBarComponent, MenuLinkComponent, VersionInfoItemComponent],
  imports: [
    CommonModule,
    TranslateModule,
    RouterModule,
    DragDropModule,
    RightPanelModule,
    IconModule,
    KendoSharedModule,
    MatRippleModule,
    MaterialSharedModule,
    CommonSharedModule,
  ],
  providers: [HideNavbarsService],
})
export class CommonNavigationModule {}
